const slides = [
  {
    src: './../Assets/Images/Notes/notes-carousel.svg',
    heading: 'Best notes for all academic subjects',
    para: "We've curated the finest content; your feedback is invaluable in our journey to continuous improvement",
  },
  {
    src: 'https://picsum.photos/seed/img2/600/400',
    heading: 'Exam practise papers uploading soon..',
    para: 'Access a comprehensive collection of previous year papers to enhance your preparation and exce',
  },
  {
    src: 'https://picsum.photos/seed/img3/600/400',
    heading: 'Mail us for any other specific content',
    para: "Don't hesitate to reach out via email if you have specific content requests or any other inquiries",
  },
];

export { slides };
